const IconPlay = (): JSX.Element => {
  return (
    <>
      {/* <path
        d="M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z"
        fill="white"
      />
      <path d="M44 28L20 41.8564L20 14.1436L44 28Z" fill="currentColor" /> */}
      <path
        d="M28 1C42.9117 1 55 13.0883 55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1Z"
        fill="white"
      />
      <path
        d="M28 1C42.9117 1 55 13.0883 55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1Z"
        className="stroke-current"
        strokeWidth="2"
      />
      <path d="M44 28L20 41.8564L20 14.1436L44 28Z" className="fill-current" />
    </>
  );
};

export default IconPlay;
